import type { YammerState } from '../../state/types';
import { getFeatureAccessSettings, getNetworkQuestionsEnablementMode } from '../featureAccessSettings/selectors';
import { isCurrentNetworkOfficeTopicsEnabled } from '../networkTopicSettings/selectors';
type NetworkQuestionsAccess = 'Disabled' | 'EnabledButNotLicensed' | 'EnabledAndLicensed';
type GetNetworkQuestionsAccess = (state: YammerState) => NetworkQuestionsAccess;
const getNetworkQuestionsAccess: GetNetworkQuestionsAccess = (state) => {
  const isNetworkQuestionsEnabled = getNetworkQuestionsEnablementMode(state) !== 'DISABLED';
  const viewerCanAccessNetworkQuestions = !!getFeatureAccessSettings(state)?.viewerCanAccessNetworkQuestions;
  const isOfficeTopicsEnabledForNetwork = isCurrentNetworkOfficeTopicsEnabled(state);
  if (!isNetworkQuestionsEnabled || !isOfficeTopicsEnabledForNetwork) {
    return 'Disabled';
  }

  if (!viewerCanAccessNetworkQuestions) {
    return 'EnabledButNotLicensed';
  }

  return 'EnabledAndLicensed';
};
type IsNetworkQuestionsDisabled = (state: YammerState) => boolean;
export const isNetworkQuestionsDisabled: IsNetworkQuestionsDisabled = (state) =>
  getNetworkQuestionsAccess(state) === 'Disabled';
type IsNetworkQuestionsEnabledButNotLicensed = (state: YammerState) => boolean;
export const isNetworkQuestionsEnabledButNotLicensed: IsNetworkQuestionsEnabledButNotLicensed = (state) =>
  getNetworkQuestionsAccess(state) === 'EnabledButNotLicensed';
type IsNetworkQuestionsEnabledAndLicensed = (state: YammerState) => boolean;
export const isNetworkQuestionsEnabledAndLicensed: IsNetworkQuestionsEnabledAndLicensed = (state) =>
  getNetworkQuestionsAccess(state) === 'EnabledAndLicensed';
